import React, { useState } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

function CheckMarkSelect({
  handleChange,
  disabled,
  dataList,
  sx,
  label,
  children,
  menuWidth,
  formStyle,
  transform,
  height,
  menuStyleProps,
}) {
  const [isFocused, setIsFocused] = React.useState(false);
  return (
    <FormControl
      sx={{
        "& .MuiInputLabel-root": { lineHeight: "1", overflow: "visible" },
        "& .MuiSvgIcon-root": {
          width: "24px",
          height: "24px",
          color: "#808080",
        },
        m: 1,
        margin: "0px",
        height: "46.29px",
        ...formStyle,
      }}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
    >
      <InputLabel
        sx={{
          transform: transform != null && !isFocused && transform,
          fontSize: "16px",
          lineHeight: "24px",
          color: disabled ? "#808080" : "#616161",
        }}
        id={`labelid-${label}`}
      >
        {label}
      </InputLabel>
      <Select
        disabled={disabled}
        labelId={`labelid-${label}`}
        multiple
        value={dataList}
        onChange={handleChange}
        input={
          <OutlinedInput
            sx={{
              height: "46.29px",
            }}
            label={label}
          />
        }
        IconComponent={KeyboardArrowDownIcon}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          sx: {
            "& .MuiPaper-root": {
              "&::-webkit-scrollbar": {
                display: "none",
              },
              height: height ? height : "auto",

              width: menuWidth || "426px",
              borderRadius: "4px",
              "& .MuiList-root": {
                padding: "0px",
                paddingTop: "17px",
                "& .MuiMenuItem-root": {
                  paddingTop: "0px",
                  paddingBottom: "8px",
                  paddingX: "16px",
                  columnGap: "8px",
                },
              },
            },
            ...menuStyleProps,
          },
        }}
        renderValue={(selected) => {
          if (selected.length > 1) {
            const arr = [selected[0], `+ ${selected.length - 1} ${label}`];
            return arr.join(", ");
          } else {
            return selected.join(", ");
          }
        }}
        sx={{
          borderRadius: "4px",
          height: "46.29px",
          backgroundColor: disabled && "#F5F5F5",
          ...sx,
        }}
      >
        {children}
      </Select>
    </FormControl>
  );
}

export default CheckMarkSelect;
